import { render, staticRenderFns } from "./CustomerServiceSteerage.vue?vue&type=template&id=2694f12d&scoped=true&"
import script from "./CustomerServiceSteerage.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceSteerage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceSteerage.vue?vue&type=style&index=0&id=2694f12d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2694f12d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCardActions,VCol,VContainer,VForm,VImg,VRow,VTextField,VTextarea})
